// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"3acf03c8","703":"d23838a3"}[chunkId] + ".chunk.js";
};